import Script from 'next/script'

export const GOOGLE_TAG_MANAGER_ID = 'GTM-KN2Q3W6Q'

export function GoogleTagManager() {
  return (
    <>
      <Script
        id="gtm-script"
        strategy="beforeInteractive"
        type="text/plain"
        data-category="analytics"
      >
        {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${GOOGLE_TAG_MANAGER_ID}');
          `}
      </Script>

      {/* Google Tag Manager - Noscript (Body) */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GOOGLE_TAG_MANAGER_ID}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  )
}
